import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseUrls } from '@app/app.constants';
import { RoutingGroup } from '@app/core/interfaces/c5/routing-group';
import { UserLevel } from '@app/core/models/user-level';
import { Utils } from '@app/shared/services/utils.service';
import { wrapError } from '@app/utils/rxjs';
import { Observable } from 'rxjs';
import { mergeMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class RoutingGroupsRepository {
  constructor(
    private http: HttpClient,
    private utils: Utils
  ) {}

  add(routingGroup: Partial<RoutingGroup>): Observable<void> {
    return this.utils.apiUrl(`/routingGroups`).pipe(
      mergeMap((url) => this.http.post<void>(url, routingGroup)),
      wrapError('routing-groups-repository:add')
    );
  }

  delete(id: number): Observable<void> {
    return this.utils.apiUrl(`/routingGroups/${id}`).pipe(
      mergeMap((url) => this.http.delete<void>(url)),
      wrapError('routing-groups-repository:delete')
    );
  }

  get(id: number): Observable<RoutingGroup> {
    return this.utils.commonApiUrl(`/routingGroups/${id}`).pipe(
      mergeMap((url) => this.http.get<RoutingGroup>(url)),
      wrapError('routing-groups-repository:get')
    );
  }

  list(): Observable<RoutingGroup[]> {
    return this.utils.commonApiUrl('/routingGroups').pipe(
      mergeMap((url) => this.http.get<RoutingGroup[]>(url)),
      wrapError('routing-groups-repository:list')
    );
  }

  listForSite(siteId: number): Observable<RoutingGroup[]> {
    const url = `/sites/${siteId}/routingGroups`;

    const urls = {
      [UserLevel.ServiceProviderAdmin]: BaseUrls.ServiceProvider.Enterprise + url,
      [UserLevel.EnterpriseAdmin]: BaseUrls.Enterprise.Enterprise + url,
    };

    return this.utils.apiUrl(urls).pipe(
      mergeMap((url) => this.http.get<RoutingGroup[]>(url)),
      wrapError('routing-groups-repository:list-for-site')
    );
  }

  update(routingGroup: RoutingGroup): Observable<void> {
    return this.utils.apiUrl(`/routingGroups/${routingGroup.id}`).pipe(
      mergeMap((url) => this.http.put<void>(url, routingGroup)),
      wrapError('routing-groups-repository:update')
    );
  }
}
